import Image from './image'
import Response from './response' 
import Auth from './auth'
import Weixin from './weixin'
import Account  from './account'
import Text from './text' 
import PaymentStatus from './paymentStatus'

function getQueryString(_this,name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
        _this.orderId=unescape(r[2]);
    }
}

export default {
    getQueryString: function (_this,name) {
        getQueryString(_this,name);
    },
    Account,
    Image,
    Response,
    Auth,
    Weixin,
    Text,
    PaymentStatus
}


// WEBPACK FOOTER //
// ./src/tools/common.js